import {throttle} from './../../../shared/pipes/throttle';
import {AppThunk} from '../index';
import {privilegeSlice} from '../../reducers/privilege';
import {httpService} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {AssignedSocialHelpResponsePayload} from '../../../shared/models/api';

export const setPrivileges = privilegeSlice.actions.setPrivileges;

export const getPrivileges = (): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const response = await httpService.get<AssignedSocialHelpResponsePayload>(getApiRoute(apiUrls.getPrivileges));
      dispatch(setPrivileges(response || []));
    }, 900);
  };
};
